import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const COMPANY_CONFIG_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('COMPANY_CONFIG');
export const COMPANY_CONFIG_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	COMPANY_CONFIG_CRUD_ACTION_CONSTANTS
);
